/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import apiService from './index'
export const createSubscription = async (data: any) => {
  return await apiService.post(`${process.env.REACT_APP_BACKEND_URL_V2}/subscription`, data)
}

export const changeSubscription = async (data: any) => {
  return await apiService.patch(`${process.env.REACT_APP_BACKEND_URL_V2}/change/subscription`, data)
}

export const updateSubscription = async (data: any) => {
  return await apiService.patch(`${process.env.REACT_APP_BACKEND_URL_V2}/subscription`, data)
}

export const getSubscriptions = async (userId: string) => {
  return await apiService.get(`${process.env.REACT_APP_BACKEND_URL_V2}/subscription/dashboard/${userId}`)
}

export const cancelSubscriptions = async (userId: string, data :any) => {
  return await apiService.patch(`${process.env.REACT_APP_BACKEND_URL_V2}/delete/subscription/${userId}`, data)
}

// ----- Plan grants (admin-granted hidden plans, incl. Founding Members) -----
// The logged-in user's pending grants. Returns `data.grants[]`, each
// { id, planId, planName, price, billingMode, status, createdAt }. Empty when the
// user has no pending grant (never invited, or already redeemed).
export const getPlanGrants = async () => {
  return await apiService.get(`${process.env.REACT_APP_BACKEND_URL_V3}/subscription/plan-grant`)
}

// Pay a granted ONE_TIME plan. `planId` selects which pending grant to pay (a
// user may hold several). Returns mode 'active' (paid, access live) or
// 'not active' with a clientSecret for 3DS — same contract as the subscription
// checkout. (SUBSCRIPTION grants complete via the normal POST /v2/subscription.)
export const payPlanGrant = async (planId: string, stripePaymentMethodId: string) => {
  return await apiService.post(
    `${process.env.REACT_APP_BACKEND_URL_V3}/subscription/plan-grant/pay`,
    { planId, stripePaymentMethodId },
  )
}
